import React, { Component } from 'react';
import './testForm.css';
import Button from '../button';
import FormGroup from '../FormGroup';
import Input from '../input';
import Select from '../select';
import EditorComponent from '../Editor';
import Checkbox from '../checkbox';
import QuestionList from '../questionList';
import Answers from '../Answers';
import {
  convertToEditor,
  convertToString,
  emptyTextEditor
} from '../../utils/Editor';
import { typograf } from '../../utils/typograf';
import Results from '../results';
import ApiService from '../../services/apiService';
import Spinner from '../spinner';
import { FilePond, registerPlugin } from 'react-filepond';
import FilePondImagePreview from 'filepond-plugin-image-preview';
import filepondPluginFileEncode from 'filepond-plugin-file-encode';
import filepondPluginFileValidateType from 'filepond-plugin-file-validate-type';

import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

registerPlugin(
  filepondPluginFileValidateType,
  FilePondImagePreview,
  filepondPluginFileEncode
);

const questions = [
  {
    answers: [
      {
        comment: emptyTextEditor(),
        text: '',
        group: '',
        correct: false,
        imageUrl: ''
      },
      {
        comment: emptyTextEditor(),
        text: '',
        group: '',
        correct: false,
        imageUrl: ''
      }
    ],
    text: '',
    imageUrl: ''
  }
];

const results = [
  {
    title: '',
    comment: emptyTextEditor(),
    intervalFrom: 0,
    intervalTo: 0,
    group: '',
    imageUrl: '',
    groupList: [],
    mailchimpTag: '',
    resultButtonLink: '',
    resultButtonText: '',
    isLeadForm: false
  }
];

class TestForm extends Component {
  state = {
    url: null,
    name: '',
    description: emptyTextEditor(),
    isPartner: false,
    isLinkBack: false,
    courseLink: '',
    value: '',
    questions: questions,
    activeQuestion: 1,
    results: results,
    load: true,
    error: false,
    backgroundImage: '',
    logoPartnerImage: '',
    isSnow: false,
    testType: 1
  };

  componentDidMount() {
    if (!this.props.edit) {
      this.setState({
        load: false
      });
    }
    if(this.props.testType) {
      const testType = Number(this.props.testType);
      this.setState({
        testType
      })
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.url !== this.props.url) this.updateTest(this.props.url);
  }

  apiService = new ApiService();

  updateTest = () => {
    if (!this.props.edit) {
      this.setState({
        ...this.state,
        load: true
      });
    }

    this.apiService
      .getQuiz(`${this.props.url}`)
      .then(
        ({
          name,
          url,
          description,
          isPartner,
          isLinkBack,
          courseLink,
          questions,
          quizResults,
           backgroundImage,
           logoPartnerImage,
            isSnow
        }) => {
          questions.forEach(value => {
            value.answers = value.answers.map((value, index) => {
              return {
                text: value.text,
                comment: convertToEditor(value.comment),
                correct: value.isCorrect,
                group: value.groupName,
                imageUrl: value.imageUrl
              };
            });

            return {
              text: value.text,
              imageUrl: value.imageUrl
            };
          });

          let newArr = [];

          quizResults.forEach((value, index) => {
            newArr.push({
              comment: convertToEditor(value.comment),
              title: value.title,
              intervalFrom: value.intervalFrom,
              imageUrl: value.imageUrl,
              groupName: value.groupName,
              groupList: value.groupList,
              intervalTo: value.intervalTo,
              mailchimpTag: value.mailchimpTag,
              resultButtonLink: value.resultButtonLink,
              resultButtonText: value.resultButtonText,
              isLeadForm: value.isLeadForm
            });
          });

          this.setState({
            results: newArr,
            url,
            name,
            description: convertToEditor(description),
            isPartner: isPartner,
            isLinkBack,
            courseLink,
            questions: questions,
            load: false,
            backgroundImage,
            logoPartnerImage,
            isSnow
          });
        }
      );
  };

  removeQuestion = e => {
    e.preventDefault();
    let { questions, activeQuestion } = this.state;
    questions.splice(activeQuestion - 1, 1);

    if (questions.length === this.state.activeQuestion - 1) {
      activeQuestion = activeQuestion - 1;
    }

    this.setState({
      questions,
      activeQuestion
    });
  };

  changeActiveQuestion = (index, pond) => {
    this.pond.removeFile()
    this.setState({
      activeQuestion: index
    });
  };

  onChangeQuestion = e => {
    const { questions } = this.state;
    questions[this.state.activeQuestion - 1].text = e.target.value;
    this.setState({
      ...this.state,
      questions: questions
    });
  };

  changeTextGroup = (index, e) => {
    const { questions } = this.state;
    const answer = (questions[this.state.activeQuestion - 1].answers[index].group = e.target.value);
    this.setState({
      ...this.state,
      questions: questions
    });
  };

  changeTextAnswer = (index, e) => {
    const { questions } = this.state;
    const answer = (questions[this.state.activeQuestion - 1].answers[index].text = e.target.value);
    this.setState({
      ...this.state,
      questions: questions
    });
  };

  removeImageQuestion = (e) => {
    e.preventDefault();
    const {questions} = this.state;
    questions[this.state.activeQuestion - 1].imageUrl = '';

    this.setState({
      ...this.state,
      questions
    })
  };


  removeImage = (field) => {
    this.setState({
      [field]: ''
    })
  };

  removeImageResults = (e, index) => {
    e.preventDefault();
    const {results} = this.state;
    results[index].imageUrl = '';

    this.setState({
      ...this.state,
      results
    })
  };

  addImageResults = (index, name) => {
    const { results } = this.state;

    let data = document.querySelector(`input[name=${name}]`).value;
    if (data) {
      results[index].imageUrl = `data:${JSON.parse(data).type};base64,${JSON.parse(data).data}`;
    } else {
      results[index].imageUrl = ''
    }
  }

  addImageQuestion = name => {
    const {questions} = this.state;
    let data = document.querySelector(`input[name=${name}]`).value;
    if (data) {
      questions[this.state.activeQuestion - 1].imageUrl = `data:${JSON.parse(data).type};base64,${JSON.parse(data).data}`;
    } else {
      questions[this.state.activeQuestion - 1].imageUrl = ''
    }

    this.setState({
      ...this.state,
      questions: questions
    })

  };

  changeCommentAnswer = (index, text) => {
    const { questions } = this.state;
    const answer = (questions[this.state.activeQuestion - 1].answers[
      index
    ].comment = text);
    this.setState({
      ...this.state,
      questions: questions
    });
  };

  changeCommentResult = (index, text) => {
    const { results } = this.state;
    const result = (results[index].comment = text);
    this.setState({
      results: results
    });
  };

  changeCorrectAnswer = (index, e) => {
    const { questions } = this.state;
    const answer = questions[this.state.activeQuestion - 1].answers[index];
    answer.correct = e.target.checked;
    questions[this.state.activeQuestion - 1].answers[index] = answer;
    this.setState({
      ...this.state,
      questions: questions
    });
  };

  changeLeadForm = (index, e) => {
    const {results} = this.state;
    const result = results[index];
    result.isLeadForm = e.target.checked;
    this.setState({
      results
    });
  }

  changeInput = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  changeResultInput = (index, e) => {
    const { results } = this.state;
    results[index][e.target.name] = e.target.value;

    this.setState({
      results
    });
  };

  changeResultGroup = (index, list, e) => {
    const { results } = this.state;
    results[index]['groupName'] = e.target.value;
    results[index]['group'] = e.target.value;
    const checkedList = list.map((el) => {
      el.isChecked = e.target.value === el.value && e.target.checked;
      return el;
    });
    results[index]['groupList'] = list;

    this.setState({
      results
    });
  }

  changeMailchimpTag = (index,e) => {
    const { results } = this.state;
    results[index][e.target.name] = e.target.value
    this.setState({
      results
    });
  }

  changeResultButtonText = (index,e) => {
    const { results } = this.state;
    results[index][e.target.name] = e.target.value
    this.setState({
      results
    });
  }

  changeResultButtonLink = (index,e) => {
    const { results } = this.state;
    results[index][e.target.name] = e.target.value
    this.setState({
      results
    });
  }

  changeCheckbox = e => {
    this.setState({
      [e.target.name]: e.target.checked
    });
  };

  changePartner = e => {
    this.setState({
      isPartner: e.target.checked
    });
  };

  changeLinkBack = e => {
    this.setState({
      isLinkBack: e.target.checked
    });
  };

  changeSnow = e => {
    this.setState({
      isSnow: e.target.checked
    });
  };

  onEditorStateChange = description => {
    this.setState({
      description
    });
  };

  createAnswer = e => {
    e.preventDefault();
    const { questions } = this.state;
    questions[this.state.activeQuestion - 1].answers.push({
      text: '',
      comment: emptyTextEditor(),
      group: '',
      correct: false,
      image: null
    });

    this.setState({
      ...this.state,
      questions: questions
    });
  };

  deleteAnswer = e => {
    e.preventDefault();
    const { questions } = this.state;
    questions[this.state.activeQuestion - 1].answers.pop();
    this.setState({
      questions: questions
    });
  };

  removeResultItem = (index, e) => {
    e.preventDefault();
    const { results } = this.state;
    results.splice(index, 1);

    this.setState({
      results
    });
  };

  addResult = (e, index) => {
    e.preventDefault();
    const { results } = this.state;
    results.push({
      title: '',
      imageUrl: '',
      comment: emptyTextEditor(),
      intervalFrom: 0,
      intervalTo: 0,
      group: '',
      mailchimpTag: '',
      resultButtonText: '',
      resultButtonLink: '',
      isLeadForm: false
    });

    this.setState({
      results: results
    });
  };

  validateTest = () => {
    let { url, name, description, questions, results } = this.state;
    let message = 'У вас есть незаполненные поля:';
    let status = true;

    if (!name.trim()) {
      message += ` Название`;
      status = false;
    }

    if (convertToString(description) === `<p></p>`) {
      message += ` Описание`;
      status = false;
    }

    questions.forEach((value, index) => {
      if (!value.text) {
        message += ` Вопрос № ${index + 1}`;
        status = false;
      }

      value.answers.forEach((value, i) => {
        if (!value.text) {
          message += ` Вариант ответа № ${i + 1} к вопросу № ${index + 1} `;
          status = false;
        }

        if(this.state.testType === 1) {
          if (convertToString(value.comment) === `<p></p>`) {
            message += ` Комментарий к варианту ответа ${i +
            1} к вопросу ${index + 1}`;
            status = false;
          }
        }
      });
    });

    results.forEach((value, index) => {
      if (!value.title) {
        message += ` Заголовок результата № ${index + 1}`;
        status = false;
      }
    });

    return { status, message };
  };

  createQuestion = () => {
    let validQuestion = this.validateCreateQuetion();
    const { questions } = this.state;
    let numberQuestion = questions.length + 1;
    if (validQuestion) {
      let newQuestions = [
        ...questions,
        {
          text: '',
          imageUrl: '',
          answers: [
            {
              comment: emptyTextEditor(),
              text: '',
              correct: false,
              group: '',
              imageUrl: ''
            },
            {
              comment: emptyTextEditor(),
              text: '',
              correct: false,
              group: '',
              imageUrl: ''
            }
          ]
        }
      ];

      this.setState({
        questions: newQuestions,
        activeQuestion: numberQuestion
      });
      this.pond.removeFile()
    } else {
      alert('Заполните все обязательные поля');
    }

  };

  validateCreateQuetion = () => {
    const question = this.state.questions[this.state.activeQuestion - 1];
    const isSimpleTest = this.state.testType;
    let status = true;

    let checkStatus = false;
    if (!question.text) {
      status = false;
    }

    question.answers.forEach((value, index) => {
      if (convertToString(value.comment) === `<p></p>` && isSimpleTest === 1) {
        status = false;
      }

      if (!value.text) {
        status = false;
      }

      if (value.correct && isSimpleTest === 1) {
        checkStatus = true;
      } else if (isSimpleTest === 2) {
        checkStatus = true;
      }
    });
    if (!checkStatus) status = false;
    return status;
  };

  createTest = e => {
    e.preventDefault();

    let validTest = this.validateTest();
    let questions = this.state.questions.map(value => {
      let answers = null;
      if(this.state.testType === 1) {
        answers = value.answers.map(answer => {
          return {
            isCorrect: answer.correct,
            text: answer.text,
            comment: typograf(convertToString(answer.comment)),
            image: answer.image
          };
        });
      } else {
        answers = value.answers.map(answer => {
          return {
            group: answer.group,
            text: answer.text,
            comment: typograf(convertToString(answer.comment)),
            image: answer.image
          };
        });
      }
      return {
        answers: answers,
        text: value.text,
        image: value.imageUrl
      };
    });

    let results = this.state.results.map(value => {
      return {
        title: value.title,
        intervalFrom: value.intervalFrom,
        intervalTo: value.intervalTo,
        imageUrl: value.imageUrl,
        group: value.groupName,
        groupList: value.groupList,
        comment: typograf(convertToString(value.comment)),
        mailchimpTag: value.mailchimpTag,
        resultButtonLink: value.resultButtonLink,
        resultButtonText: value.resultButtonText,
        isLeadForm: value.isLeadForm
      };
    });

    if (validTest.status) {
      let test = {
        name: this.state.name,
        description: typograf(convertToString(this.state.description)),
        isPartner: this.state.isPartner,
        isLinkBack: this.state.isLinkBack,
        courseLink: this.state.courseLink,
        questions: questions,
        quizResults: results,
        backgroundImage: this.state.backgroundImage,
        logoPartnerImage: this.state.logoPartnerImage,
        isSnow: this.state.isSnow,
        testType: this.state.testType
      };

      this.saveTest(test);
    } else {
      alert(validTest.message);
    }
  };

  saveTest = test => {
    this.setState({
      load: true
    });
    if (this.props.status) {
        fetch(window.location.hostname === 'localhost' ? `http://172.21.0.4/public/quizzes/${this.props.url}/edit` :`https://ppc.world/quizzes/api/public/quizzes/${this.props.url}/edit`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(test)
      }).then(response => {
        if (response.ok) {
          this.setState({
            load: false
          });
        }
      });
    } else {
      fetch(window.location.hostname === 'localhost' ? 'http://172.21.0.4/public/quizzes/create' :`https://ppc.world/quizzes/api/public/quizzes/create`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(test)
      }).then(response => {
        if (response.ok) {
          window.history.back();
        }
      });
    }
  };

  addImage = name => {

    const input =  document.querySelector(`.${name} input[name="filepond"]`)
    let data = input.value;
    if (data) {
      this.setState({
        [name]: `data:${JSON.parse(data).type};base64,${JSON.parse(data).data}`
      });
    } else {
      this.setState({
        [name]: ''
      });
    }
  };

  changeTestType = value => {
    this.setState({ testType: value })
  }

  render() {
    return (
      <div className="admin-container__inner">
        <Button
          classList="test-list__btn"
          textButton={
            this.props.status ? 'Сохранить изменения' : 'Создать тест'
          }
          onClick={this.createTest}
        />
        {this.state.load ? (
          <Spinner />
        ) : (
          <form className="test-form">
            <FormGroup className="form-group__admin">
              <h2 className="h2">Выберите тип теста</h2>
              <Select
                  testType={this.state.testType}
                  changeTestType={this.changeTestType}
              />
            </FormGroup>
            <h2 className="h2">Основная информация</h2>
            <FormGroup className="form-group__admin">
              <Input
                type="text"
                title="Название теста"
                name="name"
                value={this.state.name}
                onChange={this.changeInput}
              />
            </FormGroup>
            <FormGroup className="form-group__admin">
              <EditorComponent
                title="Краткое описание теста"
                editorState={this.state.description}
                onEditorStateChange={this.onEditorStateChange}
              />
            </FormGroup>
            <h2 className="h2">Дополнительные опции</h2>
            <FormGroup className="form-group__admin form-group_small_margin">
              <Checkbox
                  text="Добавить кнопку назад"
                  onChange={this.changeLinkBack}
                  name="isLinkBack"
                  checked={this.state.isLinkBack}
              />
            </FormGroup>
            <FormGroup className="form-group__admin">
              <Input
                  type="text"
                  title="Ссылка на курсы"
                  name="courseLink"
                  value={this.state.courseLink}
                  onChange={this.changeInput}
              />
            </FormGroup>
            <FormGroup className="form-group__admin form-group_small_margin">
              <Checkbox
                text="Партнерский материал"
                onChange={this.changePartner}
                name="isPartner"
                checked={this.state.isPartner}
              />
            </FormGroup>
            <FormGroup className="form-group__admin form-group_small_margin">
              <Checkbox
                  text="Снег"
                  onChange={this.changeSnow}
                  name="isSnow"
                  checked={this.state.isSnow}
              />
            </FormGroup>
            <div className="form-grid">
              <FormGroup className="form-group__admin">
                <h3 className="h3">Логотип партнёра</h3>
                <div className="filepond-group logoPartnerImage">
                <FilePond
                    ref={ref => this.pond = ref}
                    acceptedFileTypes={['image/*']}
                    allowFileEncode={true}
                    onaddfile={(error, file) => setTimeout( () => {
                      this.addImage('logoPartnerImage')
                    }, 1000)}
                    onremovefile={() => this.addImage('logoPartnerImage')}
                />
                {!this.state.logoPartnerImage  ?
                    <div /> :
                    this.state.logoPartnerImage.indexOf('base64') === -1 ?
                        <div className="filepond-img-wrapper">
                          <div className="filepond-img"><img src={`https://ppc.world/quizzes/api${this.state.logoPartnerImage}`}/></div>
                          <a href="#" className="link" onClick={(e) => {
                            e.preventDefault()
                            this.removeImage('logoPartnerImage')
                          }}>Удалить изображение</a>
                        </div>

                        : <div className="filepond-img-wrapper">
                          <div className="filepond-img"><img src={`${this.state.logoPartnerImage}`}/></div>
                          <a href="#" className="link" onClick={(e) => {
                            e.preventDefault()
                                this.removeImage('logoPartnerImage')}}>Удалить изображение</a>
                        </div>

                }
                </div>
              </FormGroup>
              <FormGroup className="form-group__admin">
                <h3 className="h3">Фоновое изображение</h3>
                <div className="filepond-group backgroundImage">
                  <FilePond
                      ref={ref => this.pond = ref}
                      acceptedFileTypes={['image/*']}
                      allowFileEncode={true}
                      onaddfile={(error, file) => setTimeout( () => {
                        this.addImage('backgroundImage')
                      }, 1000)}
                      onremovefile={() => this.addImage('backgroundImage')}
                  />
                  {!this.state.backgroundImage  ?
                      <div /> :
                      this.state.backgroundImage.indexOf('base64') === -1 ?
                          <div className="filepond-img-wrapper">
                            <div className="filepond-img"><img src={`https://ppc.world/quizzes/api${this.state.backgroundImage}`}/></div>
                            <a href="#" className="link" onClick={(e) => {
                              e.preventDefault();
                              this.removeImage('backgroundImage')
                            }}>Удалить изображение</a>
                          </div>
                          : <div className="filepond-img-wrapper">
                            <div className="filepond-img"><img src={`${this.state.backgroundImage}`}/></div>
                            <a href="#" className="link" onClick={(e) => {
                              e.preventDefault();
                              this.removeImage('backgroundImage')
                            }}>Удалить изображение</a>
                          </div>

                  }
                </div>
              </FormGroup>
            </div>

            <h2 className="h2">Вопросы и варианты ответов</h2>
            <QuestionList
              questions={this.state.questions}
              activeQuestion={this.state.activeQuestion}
              changeActiveQuestion={this.changeActiveQuestion}
              createQuestion={this.createQuestion}
            />
            <FormGroup className="form-group__admin form-group_small_margin">
              {this.state.activeQuestion !== 1 && (
                <Button
                  textButton="Удалить вопрос"
                  classList="remove-question"
                  onClick={this.removeQuestion}
                />
              )}
              <Input
                type="text"
                title={`Вопрос  № ${this.state.activeQuestion}`}
                value={this.state.questions[this.state.activeQuestion - 1].text}
                onChange={this.onChangeQuestion}
              />

            </FormGroup>
            <FormGroup>
             <div className="filepond-group">
                <FilePond
                    ref={ref => this.pond = ref}
                    acceptedFileTypes={['image/*']}
                    allowFileEncode={true}
                    name={`questionImage${this.state.activeQuestion}`}
                    onaddfile={(error, file) => setTimeout(() => {this.addImageQuestion(`questionImage${this.state.activeQuestion}`)}, 1000)}
                />

                {!this.state.questions[this.state.activeQuestion - 1].imageUrl ? <div /> :
                    this.state.questions[this.state.activeQuestion - 1].imageUrl.indexOf('base64') === -1 ?
                        <div className="filepond-img-wrapper">
                          <div className="filepond-img"><img src={`https://ppc.world/quizzes/api${this.state.questions[this.state.activeQuestion - 1].imageUrl}`}/></div>
                          <a href="#" className="link" onClick={this.removeImageQuestion}>Удалить изображение</a>
                        </div> :
                        <div className="filepond-img-wrapper">
                          <div className="filepond-img"><img src={`${this.state.questions[this.state.activeQuestion - 1].imageUrl}`}/></div>
                          <a href="#" className="link" onClick={this.removeImageQuestion}>Удалить изображение</a>
                        </div>
                }
              </div>
            </FormGroup>

            <Answers
              testType={this.state.testType}
              questions={this.state.questions[this.state.activeQuestion - 1]}
              changeTextAnswer={this.changeTextAnswer}
              changeTextGroup={this.changeTextGroup}
              changeCommentAnswer={this.changeCommentAnswer}
              changeCorrectAnswer={this.changeCorrectAnswer}
              createAnswer={this.createAnswer}
              removeAnswer={this.deleteAnswer}
            />

            <Results
              testType={this.state.testType}
              questions={this.state.questions}
              results={this.state.results}
              removeImageResults={this.removeImageResults}
              addImageResults={this.addImageResults}
              addResult={this.addResult}
              resultList={this.state.results}
              changeValue={this.changeResultInput}
              changeResultGroup={this.changeResultGroup}
              changeCommentResult={this.changeCommentResult}
              removeResultItem={this.removeResultItem}
              changeResultButtonText={this.changeResultButtonText}
              changeResultButtonLink={this.changeResultButtonLink}
              changeMailchimpTag={this.changeMailchimpTag}
              changeLeadForm={this.changeLeadForm}
            />
          </form>
        )}
      </div>
    );
  }
}

export default TestForm;
